import React, { useState, useEffect } from 'react';
import { API_URL, storedData, secret_key, customStyles } from '../components/Constants';
import { useNavigate, useParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import Modal from 'react-modal';
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import loading1 from "../assets/loading.gif"
import Papa from 'papaparse';

function ContactsByGroup() {
  
  const { groupid } = useParams();

  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [contacts, setContacts] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  let navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const contactGroup = queryParams.get('contact_group');

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;
  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const fetchContacts = () => {
    const getContactsURL = `${API_URL}/get_contactByGroup/${groupid}?page=${page}&limit=${50}`;
    let getContactsConfig = {
      method: 'get',
      maxBodyLength: Infinity,
      url: getContactsURL,
      headers: { 
        'Authorization': token
      }
    };

    axios
    .request(getContactsConfig)
    .then((response) => {
        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setContacts([...contacts, ...response.data]);
          setPage(page + 1);
        }
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        navigate(0);
      }
    });
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    fetchContacts();
  };

  const filteredContacts = contacts.filter((contact) => {
    const { full_name, phone_no } = contact;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      full_name.toLowerCase().includes(lowerCaseSearchTerm) ||
      phone_no.toLowerCase().includes(lowerCaseSearchTerm) 
    );
  });

  const [modalIsOpen, setIsOpen] = useState(false);
  const loadMoreContacts = () => {
    fetchContacts(); // Fetch more contacts when the user scrolls to the bottom
  };

  const openModal = () => {
    setIsOpen(true);
  }

  const closeModal = () => {
    setIsOpen(false);
  }

  const [userdata, setUserContact] = useState({
    full_name: "",
    phone_no: "",
    contact_group_id: groupid,
    company_id: logeduserData?.company_id
  });

  const handleChange = (e) =>{
    const newdata = { ...userdata }
    newdata[e.target.id] = e.target.value
    setUserContact(newdata)
  } 

  const createContact = (ev) => {
    ev.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/new_contact`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data : userdata
    };
    
    axios
    .request(config)
    .then((response) => {
      setIsSubmitting(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "New contact was created successfully",
      })
      .then(() => {
        navigate(0);
      });
    })
    .catch((error) => {
      setIsSubmitting(false);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.error,
      })
    }); 
   }

   //upload csv
  const handleFileUpload = (e) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    const file = e?.target?.files[0];
    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: (results) => {
        const parsedData = results.data.slice(1)
        .map(item => ({ 
          PhoneNo: item[0],  
          FullName: item[1],  
          contact_group_id: groupid,
          company_id: logeduserData?.company_id
        }));
        
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${API_URL}/new_group_contact`,
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
          },
          data: parsedData
        };

        axios.request(config)
          .then((response) => {
            setIsSubmitting(false);
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Contacts were imported successfully",
            }).then(() => {
              navigate(0);
            });
          })
          .catch((error) => {
            setIsSubmitting(false);
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: "Failed",
            });
          });
        
      },
    });
    
  };

  const clearContacts = () => {
    Swal.fire({
      title: 'Are you sure you want to delete?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (isSubmitting) {
        return;
      }
  
      setIsSubmitting(true);
      if (result.isConfirmed) {
        let config = {
          method: 'delete',
          maxBodyLength: Infinity,
          url: `${API_URL}/delete_GroupContacts/${groupid}`,
          headers: { 
            'Authorization': token
          }
        };
        
        axios.request(config)
        .then((response) => {
          setTimeout(() => {
            setIsSubmitting(false);
            Swal.fire({
              title: 'Deleted!',
              text: 'The contacts have been deleted.',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false
            })
            .then(() => {
              navigate(0);
            });
          }, 1000);
        })
        .catch((error) => {
          setIsSubmitting(false);
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: error?.response?.data?.error,
          })
        });
      }
    });
  }

  return (
    <div style={{ paddingLeft: '10px' }}>

      {isSubmitting && (
        <div className="loadingsubcontainer loading-overlay">
          <img className="loadingsubimg" src={loading1} alt="" />
        </div>
      )}

       <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Contacts</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Contacts</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              New Contact
              <i onClick={closeModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={createContact}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Full Name</span>
                    <input type="text" 
                      placeholder="Enter full name" 
                      required 
                      onChange={handleChange}
                      id='full_name'
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Phone Number</span>
                    <input type="tel" 
                      required
                      placeholder="Enter phone number"  
                      pattern="(0[0-9]{9})|([0-9]{9})|[0-9]{10,12}|(\+[0-9]{10,12})"
                      onChange={handleChange}
                      id='phone_no'
                    />
                  </div>  
                              
                </div>
               
                <div className="button">
                  <input type="submit" defaultValue="Save" />
                </div>
              </form>
            </div>
          </div>

        </Modal>

        <form className="form-inline searchBar">
          <div className="options-btn">
            <div>
            <button className="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Options
              <span className="caret" /></button>
            <ul className= "dropdown-menu companyActions">
            <li onClick={openModal} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
  <i className="fa fa-address-book"></i>
  <span>New Contact</span>
</li>

<li onClick={() => document.getElementById('file-input').click()} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
  <i className="fa fa-upload"></i>
  <span>Import contacts</span>
  <input
    id="file-input"
    type="file"
    accept=".csv"
    onChange={handleFileUpload}
    style={{ display: 'none' }}
  />
</li>

<li className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
  <i className="fa fa-download"></i>
  <a
    href="/files/Contacts.csv"
    className="download-link text-black hover:underline"
    download
  >
    Download template
  </a>
</li>

<li onClick={clearContacts} className="px-3 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-100">
  <i className="fa fa-trash"></i>
  <span>Clear contacts</span>
</li>

            </ul>
            </div>
            <div className="centered-element">
              <h5>{contactGroup}</h5>
            </div>
          </div>
          
          <div className="input-group input-group-sm">
            <input
              className="form-control form-control-navbar"
              type="search"
              placeholder="Search"
              aria-label="Search"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </form>

          <InfiniteScroll

            dataLength={filteredContacts.length}
            next={loadMoreContacts}
            hasMore={hasMore} // Set this to false when there is no more data to load
            loader={filteredContacts.length > 0 ? null : 
              <div className="loadingsubcontainer">
                <img className="loadingsubimg" src={loading1} alt="" />
              </div>}
            endMessage={<p>No more contacts to load.</p>}
          >
            <table id="example" className="table table-striped">
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Name</th>
                  <th>Phone No</th>
                </tr>
              </thead>
              <tbody>
                  {filteredContacts.map((contact, index) => (
                    <tr key={contact.id}>
                      <td>{index + 1}</td>
                      <td>{contact.full_name}</td>
                      <td>{contact.phone_no}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
        </InfiniteScroll>
      
    </div>
  )
}

export default ContactsByGroup
